<template>
  <div>
    TRACKER
    <div class="row">
      <div class="col-md-6 col-lg-6 col-xl-5 mx-auto">
        <div class="row justify-content-md-center">
          <div
            v-for="card in memoryCards"
            class="col-auto mb-3 flip-container"
            :class="{ flipped: card.isFlipped, matched: card.isMatched }"
            @click="flipCard(card)"
          >
            <memory-card :card="card" />
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-row justify-content-center py-3">
      <div class="turns p-3">
        <span class="btn btn-info"
          >Turns :
          <span
            class="badge"
            :class="finish ? 'badge-success' : 'badge-light'"
            >{{ turns }}</span
          >
        </span>
      </div>
      <div class="totalTime p-3">
        <span class="btn btn-info"
          >Total Time :
          <span class="badge" :class="finish ? 'badge-success' : 'badge-light'"
            >{{ min }} : {{ sec }}</span
          ></span
        >
      </div>
      <div class="turns p-3" @click="reset(true)">
        <span class="btn btn-info">
          Restart
        </span>
      </div>
      <div class="turns p-3" @click="peekFlip">
        <span class="btn btn-info">
          Peek
        </span>
      </div>
    </div>
  </div>
</template>

<script>
const cards = [
  {
    name: "1",
    img: "1.png",
    isFlipped: false,
    isMatched: false,
    title: "1"
  },
  {
    name: "2",
    img: "2.png",
    isFlipped: false,
    isMatched: false,
    title: "2"
  },
  {
    name: "3",
    img: "3.png",
    isFlipped: false,
    isMatched: false,
    title: "3"
  }
];

import _ from "lodash";
import Vue from "vue";
import MemoryCard from "./card";
import { mapGetters } from "vuex";
export default {
  name: "Display_MatchGame",
  components: {
    MemoryCard
  },
  props: {
    resource: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    this.memoryCards = _.shuffle(
      this.memoryCards.concat(_.cloneDeep(this.cards), _.cloneDeep(this.cards))
    );
    this.reset(true);
  },
  data() {
    return {
      memoryCards: [],
      flippedCards: [],
      cards: cards,
      finish: false,
      start: false,
      turns: 0,
      totalTime: {
        minutes: 0,
        seconds: 0
      }
    };
  },
  computed: {
    sec() {
      if (this.totalTime.seconds < 10) {
        return "0" + this.totalTime.seconds;
      }
      return this.totalTime.seconds;
    },
    min() {
      if (this.totalTime.minutes < 10) {
        return "0" + this.totalTime.minutes;
      }
      return this.totalTime.minutes;
    }
  },
  methods: {
    flipCard(card) {
      if (card.isMatched || card.isFlipped || this.flippedCards.length === 2)
        return;

      if (!this.start) {
        this._startGame();
      }

      card.isFlipped = true;

      if (this.flippedCards.length < 2) this.flippedCards.push(card);
      if (this.flippedCards.length === 2) this._match(card);

      this.handleAppLog({
        name: "display.flipCard",
        payload: {},
        level: "info"
      });
    },
    _match(card) {
      this.turns++;

      if (this.flippedCards[0].name === this.flippedCards[1].name) {
        setTimeout(() => {
          this.flippedCards.forEach(card => (card.isMatched = true));
          this.flippedCards = [];

          //All cards matched ?
          if (this.memoryCards.every(card => card.isMatched === true)) {
            clearInterval(this.interval);
            this.finish = true;
          }
        }, 400);
      } else {
        setTimeout(() => {
          this.flippedCards.forEach(card => {
            card.isFlipped = false;
          });
          this.flippedCards = [];
        }, 800);
      }

      this.handleAppLog({
        name: "display._match",
        payload: { turns: this.turns, match: true, card: card },
        level: "info"
      });
    },
    _startGame() {
      this._tick();
      this.interval = setInterval(this._tick, 1000);
      this.start = true;

      this.handleAppLog({
        name: "display._startGame",
        payload: { interval: this.interval },
        level: "info"
      });
    },
    _tick() {
      if (this.totalTime.seconds !== 59) {
        this.totalTime.seconds++;
        return;
      }

      this.totalTime.minutes++;
      this.totalTime.seconds = 0;
    },
    reset(shallPeek) {
      clearInterval(this.interval);

      this.cards.forEach(card => {
        Vue.set(card, "isFlipped", false);
        Vue.set(card, "isMatched", false);
      });

      setTimeout(() => {
        this.memoryCards = [];
        this.memoryCards = _.shuffle(
          this.memoryCards.concat(
            _.cloneDeep(this.cards),
            _.cloneDeep(this.cards)
          )
        );
        this.totalTime.minutes = 0;
        this.totalTime.seconds = 0;
        this.start = false;
        this.finish = false;
        this.turns = 0;
        this.flippedCards = [];
      }, 600);
      //
      if (shallPeek) this.peekFlip();

      this.handleAppLog({
        name: "display.reset",
        payload: { shallPeek: shallPeek },
        level: "info"
      });
    },
    peekFlip() {
      this.memoryCards.forEach(card => {
        if (!card.isMatched) Vue.set(card, "isFlipped", true);
      });
      setTimeout(() => {
        this.memoryCards.forEach(card => {
          if (!card.isMatched) Vue.set(card, "isFlipped", false);
        });
      }, 2000);

      this.handleAppLog({
        name: "display.peekFlip",
        payload: {},
        level: "info"
      });
    },
    handleAppLog(data) {
      this.$emit("appLog", data);
    }
  }
};
</script>

<style lang="scss" scoped>
.flip-container {
  -webkit-perspective: 1000;
  -moz-perspective: 1000;
  -o-perspective: 1000;
  perspective: 1000;
  min-height: 120px;
  cursor: pointer;
}
.front,
.back {
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -o-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transition: 0.6s;
  -webkit-transform-style: preserve-3d;
  -moz-transition: 0.6s;
  -moz-transform-style: preserve-3d;
  -o-transition: 0.6s;
  -o-transform-style: preserve-3d;
  -ms-transition: 0.6s;
  -ms-transform-style: preserve-3d;
  transition: 0.6s;
  transform-style: preserve-3d;
  top: 0;
  left: 0;
  width: 100%;
}
.back {
  -webkit-transform: rotateY(-180deg);
  -moz-transform: rotateY(-180deg);
  -o-transform: rotateY(-180deg);
  -ms-transform: rotateY(-180deg);
  transform: rotateY(-180deg);
  position: absolute;
}
.flip-container.flipped .back {
  -webkit-transform: rotateY(0deg);
  -moz-transform: rotateY(0deg);
  -o-transform: rotateY(0deg);
  -ms-transform: rotateY(0deg);
  transform: rotateY(0deg);
}
.flip-container.flipped .front {
  -webkit-transform: rotateY(180deg);
  -moz-transform: rotateY(180deg);
  -o-transform: rotateY(180deg);
  -ms-transform: rotateY(180deg);
  transform: rotateY(180deg);
}
.matched {
  opacity: 0.3;
}
</style>
